import _ from 'lodash';
import { getI18n } from 'react-i18next';

export const ERROR_BID_INVALID_MEMBER = 'validation.bid.invalidMember';
export const ERROR_BID_INVALID_USER = 'validation.bid.invalidUser';
export const ERROR_BID_INVALID_QUANTITY_OLD = 'bid.quantityInvalid';
export const ERROR_BID_INVALID_QUANTITY = 'validation.bid.invalidQuantity';
export const ERROR_BID_INVALID_PRICE = 'validation.bid.invalidPrice';
export const ERROR_BID_EMPTY_PRICE = 'validation.bid.emptyPrice';
export const ERROR_BID_BROKER_REFERENCE_TOO_LONG = 'validation.bid.brokerReferenceTooLong';
export const ERROR_BID_AUCTION_NOT_FOUND = 'validation.bid.auctionNotFound';
export const ERROR_BID_QUANTITY_CANNOT_BE_CHANGED = 'validation.bid.quantityCannotBeChanged';
export const ERROR_BID_PRICE_OUT_OF_RANGE = 'validation.price.outOfRange';
export const ERROR_BID_NOT_FOUND = 'bid.notFound';
export const ERROR_BID_ALREADY_CANCELLED = 'bid.alreadyCancelled';

export const ERROR_BID_PLACING_CASH_LIMIT_EXCEEDED_OPEN_SECURITY = 'bid.placing.cashLimitExceededOpenSecurity';
export const ERROR_BID_PLACING_CASH_LIMIT_EXCEEDED_OPEN_ENERGY = 'bid.placing.cashLimitExceededOpenEnergy';
export const ERROR_BID_PLACING_CASH_LIMIT_EXCEEDED_SLOTTED_SECURITY = 'bid.placing.cashLimitExceededSlottedSecurity';
export const ERROR_BID_PLACING_CASH_LIMIT_EXCEEDED_SLOTTED_ENERGY = 'bid.placing.cashLimitExceededSlottedEnergy';

export const ERROR_BIDS_PLACING_CASH_LIMIT_EXCEEDED_OPEN_SECURITY = 'bids.placing.cashLimitExceededOpenSecurity';
export const ERROR_BIDS_PLACING_CASH_LIMIT_EXCEEDED_OPEN_ENERGY = 'bids.placing.cashLimitExceededOpenEnergy';
export const ERROR_BIDS_PLACING_CASH_LIMIT_EXCEEDED_SLOTTED_SECURITY = 'bids.placing.cashLimitExceededSlottedSecurity';
export const ERROR_BIDS_PLACING_CASH_LIMIT_EXCEEDED_SLOTTED_ENERGY = 'bids.placing.cashLimitExceededSlottedEnergy';

export const ERROR_BID_MODIFICATION_CASH_LIMIT_EXCEEDED_OPEN_SECURITY = 'bid.modification.cashLimitExceededOpenSecurity';
export const ERROR_BID_MODIFICATION_CASH_LIMIT_EXCEEDED_OPEN_ENERGY = 'bid.modification.cashLimitExceededOpenEnergy';
export const ERROR_BID_MODIFICATION_CASH_LIMIT_EXCEEDED_SLOTTED_SECURITY = 'bid.modification.cashLimitExceededSlottedSecurity';
export const ERROR_BID_MODIFICATION_CASH_LIMIT_EXCEEDED_SLOTTED_ENERGY = 'bid.modification.cashLimitExceededSlottedEnergy';

export const ERROR_BIDS_MODIFICATION_CASH_LIMIT_EXCEEDED_OPEN_SECURITY = 'bids.modification.cashLimitExceededOpenSecurity';
export const ERROR_BIDS_MODIFICATION_CASH_LIMIT_EXCEEDED_OPEN_ENERGY = 'bids.modification.cashLimitExceededOpenEnergy';
export const ERROR_BIDS_MODIFICATION_CASH_LIMIT_EXCEEDED_SLOTTED_SECURITY = 'bids.modification.cashLimitExceededSlottedSecurity';
export const ERROR_BIDS_MODIFICATION_CASH_LIMIT_EXCEEDED_SLOTTED_ENERGY = 'bids.modification.cashLimitExceededSlottedEnergy';

export const ERROR_BID_PLACING_AUCTION_LIMIT_EXCEEDED = 'bid.placing.auctionLimitExceeded';
export const ERROR_BIDS_PLACING_AUCTION_LIMIT_EXCEEDED = 'bids.placing.auctionLimitExceeded';
export const ERROR_BID_MODIFICATION_AUCTION_LIMIT_EXCEEDED = 'bid.modification.auctionLimitExceeded';
export const ERROR_BIDS_MODIFICATION_AUCTION_LIMIT_EXCEEDED = 'bids.modification.auctionLimitExceeded';

export const VALIDATION_BID_MEMBER_DOES_NOT_HAVE_AUCTION_ZONE = 'validation.bid.memberDoesNotHaveAuctionZone';
export const VALIDATION_BID_EMPTY_USER_RACF = 'validation.bid.emptyUserRacf';
export const VALIDATION_BID_USER_SUSPENDED = 'validation.bid.userSuspended';
export const VALIDATION_BID_NOT_EMPTY_BROKER_REFERENCE = 'validation.bid.notEmptyBrokerReference';
export const VALIDATION_UPLOADED_BIDS_TOO_MANY = 'validation.uploadedBids.tooManyBids';

export const ERROR_BIDS_NOT_IN_SAME_AUCTION = 'validation.bids.bidsNotInSameAuction';

export const toFixedDecimals = (value) => {
    let result = value;
    if (typeof value === 'number') {
        result = value.toFixed(2);
    }
    return result;
};

export const createBidErrorMessage = (code, params) => { // NOSONAR javascript:S3776 // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) { // NOSONAR javascript:S1479
        case ERROR_BID_NOT_FOUND:
            result = i18n.t('auctions.bids-list.cancel-bids.error.bid-not-found');
            break;
        case ERROR_BID_ALREADY_CANCELLED:
            result = i18n.t('auctions.bids-list.cancel-bids.error.bid-already-cancelled');
            break;
        case ERROR_BIDS_NOT_IN_SAME_AUCTION:
            result = i18n.t('auctions.bids-list.modify-bids.error.bids-not-in-same-auction');
            break;
        case ERROR_BID_INVALID_MEMBER:
            result = i18n.t(`auctions.bids-list.place-bid.error.invalid-member${params.recordNumber ? '-with-record-number' : ''}`, params);
            break;
        case ERROR_BID_INVALID_USER:
            result = i18n.t('auctions.bids-list.place-bid.error.invalid-user');
            break;
        case ERROR_BID_INVALID_QUANTITY_OLD:
        case ERROR_BID_INVALID_QUANTITY:
            result = i18n.t(`auctions.bids-list.place-bid.error.invalid-quantity${params.recordNumber ? '-with-record-number' : ''}`, params);
            break;
        case ERROR_BID_INVALID_PRICE:
            result = i18n.t(`auctions.bids-list.place-bid.error.invalid-price${params.recordNumber ? '-with-record-number' : ''}`, params);
            break;
        case ERROR_BID_EMPTY_PRICE:
            result = i18n.t('auctions.bids-list.place-bid.error.empty-price');
            break;
        case ERROR_BID_BROKER_REFERENCE_TOO_LONG:
            result = i18n.t(`auctions.bids-list.place-bid.error.broker-reference-too-long${params.recordNumber ? '-with-record-number' : ''}`, _.isArray(params) ? { max: params[0] } : params);
            break;
        case ERROR_BID_AUCTION_NOT_FOUND:
            result = i18n.t('auctions.bids-list.place-bid.error.auction-not-found');
            break;
        case ERROR_BID_QUANTITY_CANNOT_BE_CHANGED:
            result = i18n.t('auctions.bids-list.modify-bids.error.quantity-cannot-be-changed');
            break;
        case ERROR_BID_PRICE_OUT_OF_RANGE:
            result = i18n.t('auctions.bids-list.modify-bids.error.price-out-of-range', { min: params[0], max: params[1] });
            break;
        case ERROR_BID_PLACING_CASH_LIMIT_EXCEEDED_OPEN_SECURITY:
            result = i18n.t('auctions.bids-list.place-bid.error.bid-cash-limit-exceeded-open-security', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                newPrice: toFixedDecimals(params.newPrice),
                newQuantity: params.newQuantity,
            });
            break;
        case ERROR_BID_PLACING_CASH_LIMIT_EXCEEDED_OPEN_ENERGY:
            result = i18n.t('auctions.bids-list.place-bid.error.bid-cash-limit-exceeded-open-energy', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                energyPerLot: params.energyPerLot,
                energyUnit: i18n.t(`unit.${params.energyUnit.toLowerCase()}`),
                newPrice: toFixedDecimals(params.newPrice),
                newQuantity: params.newQuantity,
            });
            break;
        case ERROR_BID_PLACING_CASH_LIMIT_EXCEEDED_SLOTTED_SECURITY:
            result = i18n.t('auctions.bids-list.place-bid.error.bid-cash-limit-exceeded-slotted-security', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                newPrice: toFixedDecimals(params.newPrice),
            });
            break;
        case ERROR_BID_PLACING_CASH_LIMIT_EXCEEDED_SLOTTED_ENERGY:
            result = i18n.t('auctions.bids-list.place-bid.error.bid-cash-limit-exceeded-slotted-energy', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                energyPerLot: params.energyPerLot,
                energyUnit: i18n.t(`unit.${params.energyUnit.toLowerCase()}`),
                newPrice: toFixedDecimals(params.newPrice),
            });
            break;
        case ERROR_BIDS_PLACING_CASH_LIMIT_EXCEEDED_OPEN_SECURITY:
            result = i18n.t('auctions.bids-list.place-bid.error.bids-cash-limit-exceeded-open-security', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                cashSum: toFixedDecimals(params.cashSum),
            });
            break;
        case ERROR_BIDS_PLACING_CASH_LIMIT_EXCEEDED_OPEN_ENERGY:
            result = i18n.t('auctions.bids-list.place-bid.error.bids-cash-limit-exceeded-open-energy', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                cashSum: toFixedDecimals(params.cashSum),
                energyPerLot: params.energyPerLot,
                energyUnit: i18n.t(`unit.${params.energyUnit.toLowerCase()}`),
            });
            break;
        case ERROR_BIDS_PLACING_CASH_LIMIT_EXCEEDED_SLOTTED_SECURITY:
            result = i18n.t('auctions.bids-list.place-bid.error.bids-cash-limit-exceeded-slotted-security', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                cashSum: toFixedDecimals(params.cashSum),
            });
            break;
        case ERROR_BIDS_PLACING_CASH_LIMIT_EXCEEDED_SLOTTED_ENERGY:
            result = i18n.t('auctions.bids-list.place-bid.error.bids-cash-limit-exceeded-slotted-energy', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                cashSum: toFixedDecimals(params.cashSum),
                energyPerLot: params.energyPerLot,
                energyUnit: i18n.t(`unit.${params.energyUnit.toLowerCase()}`),
            });
            break;
        case ERROR_BID_MODIFICATION_CASH_LIMIT_EXCEEDED_OPEN_SECURITY:
            result = i18n.t('auctions.bids-list.modify-bids.error.bid-cash-limit-exceeded-open-security', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                newPrice: toFixedDecimals(params.newPrice),
                newQuantity: params.newQuantity,
            });
            break;
        case ERROR_BID_MODIFICATION_CASH_LIMIT_EXCEEDED_OPEN_ENERGY:
            result = i18n.t('auctions.bids-list.modify-bids.error.bid-cash-limit-exceeded-open-energy', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                energyPerLot: params.energyPerLot,
                energyUnit: i18n.t(`unit.${params.energyUnit.toLowerCase()}`),
                newPrice: toFixedDecimals(params.newPrice),
                newQuantity: params.newQuantity,
            });
            break;
        case ERROR_BID_MODIFICATION_CASH_LIMIT_EXCEEDED_SLOTTED_SECURITY:
            result = i18n.t('auctions.bids-list.modify-bids.error.bid-cash-limit-exceeded-slotted-security', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                newPrice: toFixedDecimals(params.newPrice),
            });
            break;
        case ERROR_BID_MODIFICATION_CASH_LIMIT_EXCEEDED_SLOTTED_ENERGY:
            result = i18n.t('auctions.bids-list.modify-bids.error.bid-cash-limit-exceeded-slotted-energy', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                energyPerLot: params.energyPerLot,
                energyUnit: i18n.t(`unit.${params.energyUnit.toLowerCase()}`),
                newPrice: toFixedDecimals(params.newPrice),
            });
            break;
        case ERROR_BIDS_MODIFICATION_CASH_LIMIT_EXCEEDED_OPEN_SECURITY:
            result = i18n.t('auctions.bids-list.modify-bids.error.bids-cash-limit-exceeded-open-security', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                cashSum: toFixedDecimals(params.cashSum),
            });
            break;
        case ERROR_BIDS_MODIFICATION_CASH_LIMIT_EXCEEDED_OPEN_ENERGY:
            result = i18n.t('auctions.bids-list.modify-bids.error.bids-cash-limit-exceeded-open-energy', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                cashSum: toFixedDecimals(params.cashSum),
                energyPerLot: params.energyPerLot,
                energyUnit: i18n.t(`unit.${params.energyUnit.toLowerCase()}`),
            });
            break;
        case ERROR_BIDS_MODIFICATION_CASH_LIMIT_EXCEEDED_SLOTTED_SECURITY:
            result = i18n.t('auctions.bids-list.modify-bids.error.bids-cash-limit-exceeded-slotted-security', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                cashSum: toFixedDecimals(params.cashSum),
            });
            break;
        case ERROR_BIDS_MODIFICATION_CASH_LIMIT_EXCEEDED_SLOTTED_ENERGY:
            result = i18n.t('auctions.bids-list.modify-bids.error.bids-cash-limit-exceeded-slotted-energy', {
                cashLimit: toFixedDecimals(params.cashLimit),
                currency: params.currency,
                totalCash: toFixedDecimals(params.totalCash),
                overLimit: toFixedDecimals(params.overLimit),
                cashSum: toFixedDecimals(params.cashSum),
                energyPerLot: params.energyPerLot,
                energyUnit: i18n.t(`unit.${params.energyUnit.toLowerCase()}`),
            });
            break;
        case ERROR_BID_MODIFICATION_AUCTION_LIMIT_EXCEEDED:
            result = i18n.t('auctions.bids-list.modify-bids.error.bid-auction-limit-exceeded', params);
            break;
        case ERROR_BIDS_MODIFICATION_AUCTION_LIMIT_EXCEEDED:
            result = i18n.t('auctions.bids-list.modify-bids.error.bids-auction-limit-exceeded', params);
            break;
        case ERROR_BID_PLACING_AUCTION_LIMIT_EXCEEDED:
            result = i18n.t('auctions.bids-list.place-bid.error.bid-auction-limit-exceeded', params);
            break;
        case ERROR_BIDS_PLACING_AUCTION_LIMIT_EXCEEDED:
            result = i18n.t('auctions.bids-list.place-bid.error.bids-auction-limit-exceeded', params);
            break;
        case VALIDATION_BID_MEMBER_DOES_NOT_HAVE_AUCTION_ZONE:
            result = i18n.t(`auctions.bids-list.error.bid-member-does-not-have-auction-zone${params.recordNumber ? '-with-record-number' : ''}`, params);
            break;
        case VALIDATION_BID_EMPTY_USER_RACF:
            result = i18n.t(`auctions.bids-list.error.bid-empty-user-racf${params.recordNumber ? '-with-record-number' : ''}`, params);
            break;
        case VALIDATION_BID_USER_SUSPENDED:
            result = i18n.t(`auctions.bids-list.error.bid-user-suspended${params.recordNumber ? '-with-record-number' : ''}`, params);
            break;
        case VALIDATION_BID_NOT_EMPTY_BROKER_REFERENCE:
            result = i18n.t(`auctions.bids-list.error.bid-not-empty-broker-reference${params.recordNumber ? '-with-record-number' : ''}`, params);
            break;
        case VALIDATION_UPLOADED_BIDS_TOO_MANY:
            result = i18n.t('auctions.bids-list.error.too-many-uploaded-bids', params);
            break;
        default:
            result = undefined;
    }
    return result;
};
